import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function PosMenuPage() {
  const [searchParams] = useSearchParams();
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const path = useMemo(() => {
    const qs = searchParams.toString();
    return `/pos/menu${qs ? `?${qs}` : ''}`;
  }, [searchParams]);

  const loadPage = async () => {
    setLoading(true);
    try {
      const res = await fetch(path, { credentials: 'same-origin', cache: 'no-store' });
      const text = await res.text();
      setHtml(text);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPage();
  }, [path]);

  useEffect(() => {
    if (!html) return;

    try {
      window.parent.postMessage({ type: 'refresh' }, '*');
    } catch (_) {}

    const root = document.getElementById('pos-menu-root');
    if (!root) return;

    const updateCartCount = (count) => {
      const topWrap = root.querySelector('#topCartBadgeWrap');
      const topBadge = root.querySelector('#topCartBadge');
      const bottomWrap = root.querySelector('#bottomCartBadgeWrap');
      const bottomBadge = root.querySelector('#bottomCartBadge');
      if (!topWrap || !topBadge || !bottomWrap || !bottomBadge) return;

      if (count > 0) {
        topWrap.style.display = '';
        bottomWrap.style.display = '';
        topBadge.textContent = String(count);
        bottomBadge.textContent = `${count}개`;
      } else {
        topWrap.style.display = 'none';
        bottomWrap.style.display = 'none';
        topBadge.textContent = '0';
        bottomBadge.textContent = '0개';
      }
    };

    const onSubmit = async (e) => {
      const form = e.target.closest('.add-cart-form');
      if (!form || submitting) return;
      e.preventDefault();

      const btn = form.querySelector('.menu-add-btn');
      if (!btn) return;

      btn.classList.add('pressed');
      setTimeout(() => btn.classList.remove('pressed'), 90);
      btn.disabled = true;
      setSubmitting(true);

      try {
        const formData = new FormData(form);
        const res = await fetch(window.location.pathname + window.location.search, {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
        });

        const data = await res.json();
        if (data && data.success) {
          updateCartCount(parseInt(data.cart_count || 0, 10));
          try { window.parent.postMessage({ type: 'refresh' }, '*'); } catch (_) {}
        } else {
          alert((data && data.message) ? data.message : '장바구니 담기에 실패했습니다.');
        }
      } catch (err) {
        alert(err?.message || '장바구니 담기에 실패했습니다.');
      } finally {
        btn.disabled = false;
        setSubmitting(false);
      }
    };

    root.querySelectorAll('.add-cart-form').forEach((form) => {
      form.addEventListener('submit', onSubmit);
    });

    root.querySelectorAll('[data-open-cart]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const tableId = parseInt(btn.getAttribute('data-table-id') || '0', 10);
        try { window.parent.postMessage({ type: 'openCart', table_id: tableId }, '*'); } catch (_) {}
      });
    });

    return () => {
      root.querySelectorAll('.add-cart-form').forEach((form) => {
        form.removeEventListener('submit', onSubmit);
      });
    };
  }, [html, submitting]);

  if (loading) return <div className="p-3">로딩 중...</div>;

  let patched = html
    .replaceAll('onclick="window.parent.postMessage({type:\'openCart\', table_id: ', 'data-open-cart="1" data-table-id="')
    .replaceAll('}, \'*\');"', '"');

  return <div id="pos-menu-root" dangerouslySetInnerHTML={{ __html: patched }} />;
}
